import { FloorMovingMethodTypeDto } from '@/generated-sources/openapi';
// Building suggest images
const buildingSuggestStrong = require('@/assets/img/form/building_suggest_strong.png');
const buildingSuggestWeak = require('@/assets/img/form/building_suggest_weak.png');
// Floor images - illustration
const floorFirstIll = require('@/assets/img/form/floor_first_ill.png');
const floorFirstStandaloneIll = require('@/assets/img/form/floor_first_standalone_ill.png');
const floorMultiIll = require('@/assets/img/form/floor_multi_ill.png');
const floorMultiStandaloneIll = require('@/assets/img/form/floor_multi_standalone_ill.png');
const floorOtherIll = require('@/assets/img/form/floor_other_ill.png');
// Floor images - real
const floorFirstReal = require('@/assets/img/form/floor_first_real.png');
const floorFirstStandaloneReal = require('@/assets/img/form/floor_first_standalone_real.png');
const floorMultiReal = require('@/assets/img/form/floor_multi_real.png');
const floorMultiStandaloneReal = require('@/assets/img/form/floor_multi_standalone_real.png');
const floorOtherReal = require('@/assets/img/form/floor_other_real.png');
// Entrance images - illustration
const entranceInIll = require('@/assets/img/form/entrance_in_ill.png');
const entranceOutIll = require('@/assets/img/form/entrance_out_ill.png');
// Entrance images - real
const entranceInReal = require('@/assets/img/form/entrance_in_real.png');
const entranceOutReal = require('@/assets/img/form/entrance_out_real.png');
// Building entrance images
const buildingEntranceRoad = require('@/assets/img/form/building_entrance_road.png');
const buildingEntranceParking = require('@/assets/img/form/building_entrance_parking.png');
// Stair images
const stairIll = require('@/assets/img/form/stair_img_ill.png');
const stairReal = require('@/assets/img/form/stair_img_real.png');
// Thank you image
const thankYou = require('@/assets/img/form/thank_you.png');
const illustrationImages = {
    buildingSuggest: {
        strong: buildingSuggestStrong,
        weak: buildingSuggestWeak,
    },
    floor: {
        first: floorFirstIll,
        firstStandalone: floorFirstStandaloneIll,
        multi: floorMultiIll,
        multiStandalone: floorMultiStandaloneIll,
        other: floorOtherIll,
    },
    entrance: {
        in: entranceInIll,
        out: entranceOutIll,
    },
    buildingEntrance: {
        road: buildingEntranceRoad,
        parking: buildingEntranceParking,
    },
    stair: stairIll,
    thankYou: thankYou,
};
const realImages = {
    buildingSuggest: {
        strong: buildingSuggestStrong,
        weak: buildingSuggestWeak,
    },
    floor: {
        first: floorFirstReal,
        firstStandalone: floorFirstStandaloneReal,
        multi: floorMultiReal,
        multiStandalone: floorMultiStandaloneReal,
        other: floorOtherReal,
    },
    entrance: {
        in: entranceInReal,
        out: entranceOutReal,
    },
    buildingEntrance: {
        road: buildingEntranceRoad,
        parking: buildingEntranceParking,
    },
    stair: stairReal,
    thankYou: thankYou,
};
// 이미지 스타일 플래그 - 여기서 전역 변경
const IMAGE_STYLE = 'real';
export function getFormImages(style = IMAGE_STYLE) {
    return style === 'real' ? realImages : illustrationImages;
}
// 플래그에 따라 자동 선택된 이미지
export const formImages = IMAGE_STYLE === 'real' ? realImages : illustrationImages;
export const STEPS = ['floor', 'info', 'floorMovement'];
// 폼 에러 토스트 옵션 (버튼 위에 표시)
export const FORM_TOAST_OPTIONS = { position: -90 };
export const FLOOR_OPTIONS = [
    { key: 'firstFloor', label: '네, 1층에 있어요' },
    { key: 'otherFloor', label: '아니요, 다른층이에요' },
    { key: 'multipleFloors', label: '1층을 포함한 여러층이에요' },
    { key: 'standalone', label: '단독건물이에요' },
];
export const STANDALONE_BUILDING_OPTIONS = [
    { key: 'singleFloor', label: '단독 1층 건물이에요' },
    { key: 'multipleFloors', label: '여러층 건물이에요' },
];
export const makeFloorMovementOptions = (isStandaloneBuilding, currentOptions = []) => {
    const isUnknownSelected = currentOptions.includes(FloorMovingMethodTypeDto.Unknown);
    const isAnyMethodSelected = currentOptions.length > 0 && !isUnknownSelected;
    if (isStandaloneBuilding) {
        return [
            {
                label: '엘리베이터',
                value: FloorMovingMethodTypeDto.PlaceElevator,
                disabled: isUnknownSelected,
            },
            {
                label: '계단',
                value: FloorMovingMethodTypeDto.PlaceStairs,
                disabled: isUnknownSelected,
            },
            {
                label: '에스컬레이터',
                value: FloorMovingMethodTypeDto.PlaceEscalator,
                disabled: isUnknownSelected,
            },
            {
                label: '확인 어려움',
                value: FloorMovingMethodTypeDto.Unknown,
                disabled: isAnyMethodSelected,
            },
        ];
    }
    return [
        {
            label: '매장 내부\n엘리베이터',
            value: FloorMovingMethodTypeDto.PlaceElevator,
            disabled: isUnknownSelected,
        },
        {
            label: '매장 외부\n엘리베이터',
            value: FloorMovingMethodTypeDto.BuildingElevator,
            disabled: isUnknownSelected,
        },
        {
            label: '매장 내부\n계단',
            value: FloorMovingMethodTypeDto.PlaceStairs,
            disabled: isUnknownSelected,
        },
        {
            label: '매장 외부\n계단',
            value: FloorMovingMethodTypeDto.BuildingStairs,
            disabled: isUnknownSelected,
        },
        {
            label: '매장 내부\n에스컬레이터',
            value: FloorMovingMethodTypeDto.PlaceEscalator,
            disabled: isUnknownSelected,
        },
        {
            label: '매장 외부\n에스컬레이터',
            value: FloorMovingMethodTypeDto.BuildingEscalator,
            disabled: isUnknownSelected,
        },
        {
            label: '확인 어려움',
            value: FloorMovingMethodTypeDto.Unknown,
            disabled: isAnyMethodSelected,
        },
    ];
};
export const GUIDE_CONTENTS = {
    firstFloor: {
        title: '건물 1층에 있는 장소\n정보 등록하는 방법',
        steps: [
            { number: 1, description: '매장 출입구 위치를 선택해요' },
            { number: 2, description: '입구 사진을 촬영한 후' },
            { number: 3, description: '계단, 경사로 등 접근성 정보를 입력하면' },
            { number: 4, description: '끝!' },
        ],
        additionalInfo: '건물 정보까지 입력하면,\n더 큰 도움이 된다는 사실 기억해주세요💙',
        image: formImages.floor.first,
    },
    otherFloor: {
        title: '1층이 아닌 다른 층에 있는 장소\n정보 등록하는 법',
        steps: [
            { number: 1, description: '매장 출입구 위치를 선택해요' },
            { number: 2, description: '입구 사진을 촬영한 후' },
            { number: 3, description: '계단, 경사로 등 접근성 정보를 입력하고' },
            { number: 4, description: '장소의 층까지 이동하는 방법을 등록하면' },
            { number: 5, description: '끝!' },
        ],
        additionalInfo: '건물 정보까지 입력하면,\n더 큰 도움이 된다는 사실 기억해주세요💙',
        image: formImages.floor.other,
    },
    multipleFloors: {
        title: '1층을 포함한 여러 층에 있는 장소\n정보 등록 하는 법',
        steps: [
            { number: 1, description: '매장 출입구 위치를 선택해요' },
            { number: 2, description: '입구 사진을 촬영한 후' },
            { number: 3, description: '계단, 경사로 등 접근성 정보를 입력하고' },
            { number: 4, description: '층간 이동 정보를 입력하면' },
            { number: 5, description: '끝!' },
        ],
        additionalInfo: '건물 정보까지 입력하면,\n더 큰 도움이 된다는 사실 기억해주세요💙',
        image: formImages.floor.multi,
    },
    standaloneSingleFloor: {
        title: '단독건물인 장소\n정보 등록 하는 방법',
        steps: [
            { number: 1, description: '매장 출입구를 촬영해요' },
            { number: 2, description: '계단, 경사로 등 접근성 정보를 입력하면' },
            { number: 3, description: '끝!' },
        ],
        additionalInfo: '기타정보나 특이사항을 입력하면,\n더 큰 도움이 된다는 사실 기억해주세요💙',
        image: formImages.floor.firstStandalone,
    },
    standaloneMultipleFloors: {
        title: '단독건물인 장소\n정보 등록 하는 방법',
        steps: [
            { number: 1, description: '건물 전경보다는 매장 출입구를 촬영해주세요' },
            { number: 2, description: '매장 출입문이 전체적으로 나오도록 촬영하고' },
            { number: 3, description: '계단, 경사로 등 접근성 정보를 입력합니다' },
            { number: 4, description: '층간 이동 방법도 알려주시면' },
            { number: 5, description: '끝!' },
        ],
        additionalInfo: '기타정보나 특이사항을 입력하면,\n더 큰 도움이 된다는 사실 기억해주세요💙',
        image: formImages.floor.multiStandalone,
    },
};
